// extracted by mini-css-extract-plugin
export default {"sensorMenu":"sensor-menu_sensorMenu__xJJ+C","menuOption":"sensor-menu_menuOption__D7Ez3","selected":"sensor-menu_selected__stwfk","divider":"sensor-menu_divider__+5JK0"};